
// imports
import { setGlobalAppData, setFormFieldErrorContainerMaxWidth, setResetOtpTimer, setFormHelperMessageContainerMaxWidth, updateGlobalAppData, loadScripts, showSocialLoginForm, hideSocialLoginForm, clearResendOtpTimer, getPropIfNotNull, handleSocialMediaShare, generatePublishLinks, copyShareLink, copyEmbedCode, setFormSubmitMessageContainerMaxWidth, disableButtonById, getProductPublishRequestBody, resetGlobalAppData } from "./scripts/utils";
import { GOOGLE_CLIENT_ID, FACEBOOK_APP_ID, APP_DATA, APP_ID, LOG_IN_WITH_GOOGLE_BUTTON_ID, LOG_IN_WITH_FACEBOOK_BUTTON_ID, FORM_CONTROL, FORM_SUBMIT_MESSAGE_TEXT_ID, FORM_SUBMIT_BUTTON_ID, LOGIN_FORM, FORM_CONTROL_FIELD, SIGN_UP_FORM, SIGN_UP_OTP_FORM, LOGIN_FORM_CONTROL_ID_LIST, SIGN_UP_FORM_CONTROL_ID_LIST, SIGN_UP_OTP_FORM_CONTROL_ID_LIST, FORM_SUBMIT_STATUS, COUNTRY_DIAL_CODES, LOGIN_LINK_ID, SIGN_UP_LINK_ID, APP_EVENT_FORM_RENDERED, APP_EVENT_FORM_REMOVED, APP_EVENT_MODAL_OPENED, APP_EVENT_MODAL_CLOSED, APP_EVENT_LOGIN_SUCCESS, APP_EVENT_LOGIN_FAILED, APP_EVENT_SIGN_UP_SUCCESS, APP_EVENT_SIGN_UP_FAILED, SHOPTYPE_PAGE_LINK, PROVIDER_GOOGLE, PROVIDER_FACEBOOK, GOOGLE_LOGO_CODE, FACEBOOK_LOGO_CODE, SHOPTYPE_LOGO_CODE, APP_EVENT_MODAL_CLOSED_BY_USER, FORM, MODAL, APP_VERSION, INCORRECT_COSELL_DETAILS_MESSAGE, COSELL_STEPS_LOGO, SOCIAL_MEDIA_LOGO, SOCIAL_MEDIA_SHARE_BUTTON_ID, SOCIAL_MEDIA_PLATFORMS, FORM_SUBMIT_BUTTON_LOADING_CLASS, COSELL_PUBLISH_FORM, FORGOT_PASSWORD_LINK_ID, RETURN_TO_LOGIN_LINK_ID, FORGOT_PASSWORD_FORM, RESET_PASSWORD_FORM, FORGOT_PASSWORD_FORM_CONTROL_ID_LIST, RESET_PASSWORD_FORM_CONTROL_ID_LIST, FORM_SUBMIT_MESSAGE_CONTAINER_ID, MEDIUM_COPY, MEDIUM_EMBED } from "./scripts/constants";
import { resendVerificationOtp, loginAndGetToken, signUpAndGetStatus, submitOtpAndGetToken, socialLoginAndGetToken, forgotPasswordFormSubmitAndGetStatus, resetPasswordFormSubmitAndGetStatus, publishProduct } from "./scripts/apis";
import { validateForm, getAppEventData, resetForm, disableFormInputFields } from "./scripts/handlers";

// global app data
let appData = null;

// stLoginHandlerOpenedAs value will either be "form" or "modal" depending on the way the app is created
let stLoginHandlerOpenedAs = null;

// isCosellJourney value can either be false or true depending on if the current instance of app is opened as a cosell journey or not
let isCosellJourney = false;

// appInstanceCount stores the number of instances of the app, its min value can be 0 and max 1 i.e., only one instance of app can run
let appInstanceCount = 0;

// socialLoginInitialized stores the social login provider's initialization state
let socialLoginInitialized = { google: false, facebook: false };

//  sendAppEvent(): this function needs to be invoked with the app data which is
//  generated by invoking getAppEventData() with an argument as getAppEventData(<app event>, { token: <token> })
//  this function must be invoked for different app events after rendering to removing of the form or opening to closing of the modal and also
//  during successful or failed login or sign-up
let sendAppEvent = null;

// formSubmitStatus stores the submit status of different forms
let formSubmitStatus = { resetPasswordForm: false };

// resetFormSubmitStatus resets the submit status of different forms
let resetFormSubmitStatus = () => { formSubmitStatus.resetPasswordForm = false };

// exports
export const renderSTLoginForm = (divId, client, callback) => {
  try {
    if (appInstanceCount >= 1) {
      throw `renderSTLoginForm(): Cannot create multiple instances of ${APP_ID}`;
    }

    // loading scripts to document
    loadScripts([
      "https://apis.google.com/js/api:client.js",
      `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0&appId=${FACEBOOK_APP_ID}`,
    ], () => {
      setGlobalAppData(); // creates an object under window required for storing app information
      appData = window[APP_DATA]; // assigning the reference of the object created with setGlobalAppData()
      createForm(divId, client, callback);  // creating and rendering the login form by providing the div element's id where the form will be rendered, client details and a callback function that will be invoked for form events
      // setUserCountryAndDialCode();  // update the dial code and country using location services
    });
  } catch (err) {
    console.error(err);
  }
};

export const removeSTLoginForm = () => {
  try {
    if (stLoginHandlerOpenedAs === FORM && appInstanceCount === 1) {
      removeFormOrModal();

      // clear cosell journey
      if (isCosellJourney) {
        isCosellJourney = false;
      }

      // reset app instance count
      appInstanceCount = 0;
      // reset app data
      resetGlobalAppData();
      // reset form submit status
      resetFormSubmitStatus();

      // sending form removed event
      sendAppEvent(getAppEventData(APP_EVENT_FORM_REMOVED, { token: null }));
    }
  } catch (err) {
    console.error(err);
  }
};

export const openSTLoginModal = (client, callback) => {
  try {
    if (appInstanceCount >= 1) {
      throw `openSTLoginModal(): Cannot create multiple instances of ${APP_ID}`;
    }

    // loading scripts to document
    loadScripts([
      "https://apis.google.com/js/api:client.js",
      `https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v12.0&appId=${FACEBOOK_APP_ID}`,
    ], () => {
      setGlobalAppData(); // creates an object under window required for storing app information
      appData = window[APP_DATA]; // assigning the reference of the object created with setGlobalAppData()
      createModal(client, callback);  // creating and opening login modal along with providing the client details and a callback function that will be invoked for modal events
      // setUserCountryAndDialCode();  // update the dial code and country using location services
    });
  } catch (err) {
    console.error(err);
  }
};

export const closeSTLoginModal = (closeEventType = APP_EVENT_MODAL_CLOSED) => {
  try {
    const rootDiv = document.getElementById(`${APP_ID}-root`);

    if (rootDiv && stLoginHandlerOpenedAs === MODAL && appInstanceCount === 1) {
      document.body.removeChild(rootDiv);

      // clear cosell journey
      if (isCosellJourney) {
        isCosellJourney = false;
      }

      // reset app instance count
      appInstanceCount = 0;
      // reset app data
      resetGlobalAppData();
      // reset form submit status
      resetFormSubmitStatus();

      // sending modal close event
      if (closeEventType === APP_EVENT_MODAL_CLOSED_BY_USER) {
        sendAppEvent(getAppEventData(APP_EVENT_MODAL_CLOSED_BY_USER, { token: null }));
      } else {
        sendAppEvent(getAppEventData(APP_EVENT_MODAL_CLOSED, { token: null }));
      }
    }
  } catch (err) {
    console.error(err);
  }
};

// google
var auth2 = null;

const initGoogle = () => {
  gapi.load("auth2", () => {
    if (!socialLoginInitialized.google) {
      auth2 = gapi.auth2.init({
        client_id: GOOGLE_CLIENT_ID,
        cookiepolicy: "single_host_origin",
      });
      socialLoginInitialized.google = true;
    }
    attachLoginToGoogleButton(document.getElementById(LOG_IN_WITH_GOOGLE_BUTTON_ID));
  });
};

const attachLoginToGoogleButton = (element) => {
  auth2.attachClickHandler(element, {},
    (googleUser) => {
      let authRes = googleUser.getAuthResponse(true);

      if (authRes.id_token) {
        (async () => {
          const stLoginToken = await socialLoginAndGetToken(authRes.id_token, PROVIDER_GOOGLE, appData.activeForm);

          if (stLoginToken) {
            let modalEvent;

            if (appData.activeForm === LOGIN_FORM) {
              modalEvent = APP_EVENT_LOGIN_SUCCESS;
            } else {
              modalEvent = APP_EVENT_SIGN_UP_SUCCESS;
            }

            sendAppEvent(getAppEventData(modalEvent, { token: stLoginToken }));

            if (isCosellJourney) {
              showCosellPublishForm(generatePublishLinks, [stLoginToken]);
            }
          } else {
            let modalEvent;

            if (appData.activeForm === LOGIN_FORM) {
              modalEvent = APP_EVENT_LOGIN_FAILED;
            } else {
              modalEvent = APP_EVENT_SIGN_UP_FAILED;
            }

            sendAppEvent(getAppEventData(modalEvent, { token: null }));
          }
        })();
      }
    }, (error) => {
      console.error(JSON.stringify(error, undefined, 2));
    });
};

// facebook
const initFacebook = () => {
  if (!socialLoginInitialized.facebook) {
    window.fbAsyncInit = () => {
      FB.init({
        appId: FACEBOOK_APP_ID,
        cookie: true,
        xfbml: true,
        version: "v12.0"
      });
    };

    socialLoginInitialized.facebook = true;
  }
};

const handleLogInToFacebook = () => {
  FB.getLoginStatus(response => {
    if (response.status === "connected") {
      validateFBLoginPermissions(response.authResponse.accessToken);
    } else {
      const scope = "public_profile,email";

      FB.login((loginResponse) => {
        if (loginResponse.authResponse && loginResponse.status === "connected") {
          validateFBLoginPermissions(loginResponse.authResponse.accessToken);
        } else {
          //User cancelled FB Login
        }
      }, { scope, return_scopes: true, auth_type: "" });
    }
  });
};

const validateFBLoginPermissions = (currentAccessToken) => {
  FB.api("/me/permissions", (response) => {
    const emailPermission = response.data.find(p => p.permission === "email");

    if (!emailPermission || emailPermission.status === "declined") {
      if (confirm("Permission for your email address is required for Login, would you like to retry?")) {
        const scope = "public_profile,email";

        FB.login((loginResponse) => {
          if (loginResponse.authResponse && loginResponse.status === "connected") {
            validateFBLoginPermissions(loginResponse.authResponse.accessToken);
          } else {
            // User declined to provide permissions again :(
          }
        }, { scope, return_scopes: true, auth_type: "rerequest" });
      } else {
        // User declined to provide permissions
      }
    } else {
      (async () => {
        const stLoginToken = await socialLoginAndGetToken(currentAccessToken, PROVIDER_FACEBOOK, appData.activeForm);

        if (stLoginToken) {
          let modalEvent;

          if (appData.activeForm === LOGIN_FORM) {
            modalEvent = APP_EVENT_LOGIN_SUCCESS;
          } else {
            modalEvent = APP_EVENT_SIGN_UP_SUCCESS;
          }

          sendAppEvent(getAppEventData(modalEvent, { token: stLoginToken }));

          if (isCosellJourney) {
            showCosellPublishForm(generatePublishLinks, [stLoginToken]);
          }
        } else {
          let modalEvent;

          if (appData.activeForm === LOGIN_FORM) {
            modalEvent = APP_EVENT_LOGIN_FAILED;
          } else {
            modalEvent = APP_EVENT_SIGN_UP_FAILED;
          }

          sendAppEvent(getAppEventData(modalEvent, { token: null }));
        }
      })();
    }
  });
};

// html
const cosellStepsFormHtml = (appOpenedAs) => {
  return `<div class="${APP_ID}-app-header">
  <h2 class="${APP_ID}-h2">Welcome to Coselling!${appOpenedAs === MODAL ? modalCloseButtonHtml() : ""}</h2>
</div>
<div class="${APP_ID}-app-subtitle">
  <h4 class="${APP_ID}-h4 ${APP_ID}-primary-text">Powering the Influencer in YOU!</h4>
</div>
<div id="${APP_ID}-app-body" class="${APP_ID}-app-body">
  <div class="${APP_ID}-app-subtitle">
    <h2 class="${APP_ID}-h2 ${APP_ID}-primary-text ${APP_ID}-ft-wt-500">3 easy steps to Coselling</h2>
  </div>
  <div class="${APP_ID}-cosell-steps-grid">
    <div class="${APP_ID}-cosell-step">
      <img src="${COSELL_STEPS_LOGO.step1.code}" alt="${COSELL_STEPS_LOGO.step1.alt}" />
      <div><span class="${APP_ID}-subtitle2 ${APP_ID}-primary-text">Become a Member</span></div>
    </div>
    <div class="${APP_ID}-cosell-step">
      <img src="${COSELL_STEPS_LOGO.step2.code}" alt="${COSELL_STEPS_LOGO.step2.alt}" />
      <div><span class="${APP_ID}-subtitle2 ${APP_ID}-primary-text">Explore Shop</span></div>
    </div>
    <div class="${APP_ID}-cosell-step">
      <img src="${COSELL_STEPS_LOGO.step3.code}" alt="${COSELL_STEPS_LOGO.step3.alt}" />
      <div><span class="${APP_ID}-subtitle2 ${APP_ID}-primary-text">Cosell & Earn</span></div>
    </div>
  </div>
  <div class="${APP_ID}-cosell-steps-description-container">
    <div class="${APP_ID}-cosell-step-description">
      <span class="${APP_ID}-subtitle2 ${APP_ID}-ft-wt-400"><span class="${APP_ID}-primary-text">STEP 1:</span>&nbsp;Register as a Coseller!</span>
    </div>
    <div class="${APP_ID}-cosell-step-description">
      <span class="${APP_ID}-subtitle2 ${APP_ID}-ft-wt-400"><span class="${APP_ID}-primary-text">STEP 2:</span>&nbsp;Hit the Cosell button on the Product page to get a unique referral link!</span>
    </div>
    <div class="${APP_ID}-cosell-step-description">
      <span class="${APP_ID}-subtitle2 ${APP_ID}-ft-wt-400"><span class="${APP_ID}-primary-text">STEP 3:</span>&nbsp;Share the link as a post on your social media accounts!</span>
    </div>
  </div>
  <div class="${APP_ID}-cosell-footer-message-container"><h4 class="${APP_ID}-h4 ${APP_ID}-primary-text ${APP_ID}-ft-wt-500">And that’s it! Every referral earns you real money!</h4></div>
  <button id="${FORM_SUBMIT_BUTTON_ID.cosellStepsForm.proceedToRegister}" class="${APP_ID}-button ${APP_ID}-button-primary">
    <span class="${APP_ID}-button-text">Proceed to Register</span>
  </button>
</div>
`;
};

const cosellPublishFormHtml = (appOpenedAs) => {
  return `<div class="${APP_ID}-app-header">
  <h2 class="${APP_ID}-h2">Publish your Product!${appOpenedAs === MODAL ? modalCloseButtonHtml() : ""}</h2>
</div>
<div id="${APP_ID}-app-body" class="${APP_ID}-app-body">
  <div class="${APP_ID}-mb-12">
    <div class="${APP_ID}-app-subtitle">
      <h4 class="${APP_ID}-h4 ${APP_ID}-primary-text">Here’s your unique Cosell link!</h4>
    </div>
    <div class="${APP_ID}-mb-4">
      <span class="${APP_ID}-caption-text">Copy the below link and directly share it on website platform of your choice or email this link to someone.</span>
    </div>
    <!-- share link -->
    <div class="${APP_ID}-form-control ${APP_ID}-width-100">
      <input readonly name="${FORM_CONTROL.cosellPublishForm.shareLink.name}" id="${FORM_CONTROL.cosellPublishForm.shareLink.id}" type="text" class="${APP_ID}-form-field-input" placeholder="Share Link" />
    </div>
    <button disabled id="${FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyShareLink}" class="${APP_ID}-button ${APP_ID}-button-primary ${FORM_SUBMIT_BUTTON_LOADING_CLASS}">
      <span class="${APP_ID}-button-text">Copy Link</span>
    </button>
  </div>
  <div>
    <div class="${APP_ID}-app-subtitle">
      <h4 class="${APP_ID}-h4 ${APP_ID}-primary-text">Share on Blogs</h4>
    </div>
    <div class="${APP_ID}-mb-4">
      <span class="${APP_ID}-caption-text">Copy the below code and paste it onto the HTML editor of your blog or website platform of your choice, and generate a Shoptype product card for your audience to purchase from.</span>
    </div>
    <!-- embed code -->
    <div class="${APP_ID}-form-control ${APP_ID}-width-100">
      <textarea
        readonly
        rows="4"
        name="${FORM_CONTROL.cosellPublishForm.embedCode.name}"
        id="${FORM_CONTROL.cosellPublishForm.embedCode.id}"
        class="${APP_ID}-form-field-input ${APP_ID}-form-field-textarea"
        placeholder="Embed Code"
      ></textarea>
    </div>
    <button disabled id="${FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyEmbedCode}" class="${APP_ID}-button ${APP_ID}-button-primary ${FORM_SUBMIT_BUTTON_LOADING_CLASS}">
      <span class="${APP_ID}-button-text">Copy Code</span>
    </button>
  </div>
  <!-- form submit message -->
  <div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
    <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[COSELL_PUBLISH_FORM]}" class="${APP_ID}-caption-text"></span>
  </div>
  <div class="${APP_ID}-mt-12">
    <div class="${APP_ID}-app-subtitle">
      <h4 class="${APP_ID}-h4 ${APP_ID}-primary-text">Share on Social Media</h4>
    </div>
    <div class="${APP_ID}-social-media-button-container">
      <button disabled id="${SOCIAL_MEDIA_SHARE_BUTTON_ID.facebook}" class="${APP_ID}-social-media-share-button">
        <img src="${SOCIAL_MEDIA_LOGO.facebook.code}" alt="${SOCIAL_MEDIA_LOGO.facebook.alt}" />
      </button>
      <button disabled id="${SOCIAL_MEDIA_SHARE_BUTTON_ID.twitter}" class="${APP_ID}-social-media-share-button">
        <img src="${SOCIAL_MEDIA_LOGO.twitter.code}" alt="${SOCIAL_MEDIA_LOGO.twitter.alt}" />
      </button>
      <button disabled id="${SOCIAL_MEDIA_SHARE_BUTTON_ID.pinterest}" class="${APP_ID}-social-media-share-button">
        <img src="${SOCIAL_MEDIA_LOGO.pinterest.code}" alt="${SOCIAL_MEDIA_LOGO.pinterest.alt}" />
      </button>
      <button disabled id="${SOCIAL_MEDIA_SHARE_BUTTON_ID.whatsapp}" class="${APP_ID}-social-media-share-button">
        <img src="${SOCIAL_MEDIA_LOGO.whatsapp.code}" alt="${SOCIAL_MEDIA_LOGO.whatsapp.alt}" />
      </button>
    </div>
  </div>
</div>
`;
};

const mainLoginFormHtml = (appOpenedAs) => {
  return `<div class="${APP_ID}-app-header">
  <h2 id="${APP_ID}-app-header-text" class="${APP_ID}-h2">Login${appOpenedAs === MODAL ? modalCloseButtonHtml() : ""}</h2>
</div>
<div class="${APP_ID}-app-subtitle">
  <h4 class="${APP_ID}-h4">
    To continue to&nbsp;<a href="${appData.url}" target="_blank" rel="noopener"><span class="${APP_ID}-primary-text ${APP_ID}-link">${appData.name}</span></a>
  </h4>
</div>
<div id="${APP_ID}-app-body" class="${APP_ID}-app-body">
  <div id="${APP_ID}-login-sign-up-form-container">
    ${loginFormHtml()}
  </div>
  <div id="${APP_ID}-social-login-container">
    ${socialLoginFormHtml()}
  </div>
  <div id="${APP_ID}-link-to-login-sign-up-container" class="${APP_ID}-mt-4 ${APP_ID}-mb-4 ${APP_ID}-text-center">
    ${linkToSignUpHtml()}
  </div>
</div>
`;
};

const appFooterHtml = () => {
  return `<div class="${APP_ID}-app-footer">
  <div class="${APP_ID}-flex">
    <img class="${APP_ID}-image-small" alt="shoptype logo" width="16px" height="16px" style="margin: 0 2px;" src="${SHOPTYPE_LOGO_CODE}" />
  </div>
  <div>
    <h5 class="${APP_ID}-h5">
      Powered by&nbsp;<a href="${SHOPTYPE_PAGE_LINK}" target="_blank" rel="noopener"><span class="${APP_ID}-primary-text ${APP_ID}-link">Shoptype</span></a>
    </h5>
  </div>
</div>
`;
};

const modalCloseButtonHtml = () => {
  return `<button id="${APP_ID}-modal-close-button" class="${APP_ID}-button-close-times">
  <svg focusable="false" viewBox="0 0 24 24">
    <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
  </svg>
</button>
`;
};

const socialLoginFormHtml = () => {
  return `<hr class="${APP_ID}-horizontal-separator" />
  <!-- google -->
  <button id="${LOG_IN_WITH_GOOGLE_BUTTON_ID}" class="${APP_ID}-button ${APP_ID}-button-social">
    <div class="${APP_ID}-flex ${APP_ID}-justify-space-between ${APP_ID}-align-center">
      <div>
        <span id="${APP_ID}-social-button-text-google" class="${APP_ID}-button-text">Log in with Google</span>
      </div>
      <div class="${APP_ID}-flex">
        <img class="${APP_ID}-image-small" alt="google logo" width="16px" height="16px" style="margin: 0 2px;" src="${GOOGLE_LOGO_CODE}" />
      </div>
    </div>
  </button>
  <!-- facebook -->
  <button id="${LOG_IN_WITH_FACEBOOK_BUTTON_ID}" class="${APP_ID}-button ${APP_ID}-button-social">
    <div class="${APP_ID}-flex ${APP_ID}-justify-space-between ${APP_ID}-align-center">
      <div>
        <span id="${APP_ID}-social-button-text-facebook" class="${APP_ID}-button-text">Log in with Facebook</span>
      </div>
      <div class="${APP_ID}-flex">
        <img class="${APP_ID}-image-small" alt="facebook logo" width="16px" height="16px" style="margin: 0 2px;" src="${FACEBOOK_LOGO_CODE}" />
      </div>
    </div>
  </button>
  `;
};

const loginFormHtml = () => {
  return `<!-- email address -->
  <div class="${APP_ID}-form-control">
    <input name="${FORM_CONTROL.loginForm.email.name}" id="${FORM_CONTROL.loginForm.email.id}" type="text" class="${APP_ID}-form-field-input" placeholder="Email Address" />
    <div class="${APP_ID}-form-field-error-container">
      <span name="${FORM_CONTROL.loginForm.emailError.name}" id="${FORM_CONTROL.loginForm.emailError.id}" class="${APP_ID}-caption-text"></span>
    </div>
  </div>
  <!-- password -->
  <div class="${APP_ID}-form-control">
    <input name="${FORM_CONTROL.loginForm.password.name}" id="${FORM_CONTROL.loginForm.password.id}" type="password" class="${APP_ID}-form-field-input" placeholder="Password" />
    <div class="${APP_ID}-form-field-error-container">
      <span name="${FORM_CONTROL.loginForm.passwordError.name}" id="${FORM_CONTROL.loginForm.passwordError.id}" class="${APP_ID}-caption-text"></span>
    </div>
  </div>
  ${linkToForgotPasswordHtml()}
  <!-- form submit message -->
  <div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
    <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[LOGIN_FORM]}" class="${APP_ID}-caption-text"></span>
  </div>
  <!-- submit button -->
  <button id="${FORM_SUBMIT_BUTTON_ID.loginForm.submitButton}" class="${APP_ID}-button ${APP_ID}-button-primary">
    <span class="${APP_ID}-button-text">Submit</span>
  </button>
  `;
};

const signUpFormHtml = () => {
  return `<div class="${APP_ID}-sm-block-md-flex">
  <!-- first name -->
  <div class="${APP_ID}-form-control ${APP_ID}-form-control-first-name ${APP_ID}-width-100">
    <input name="${FORM_CONTROL.signUpForm.firstName.name}" id="${FORM_CONTROL.signUpForm.firstName.id}" type="text" class="${APP_ID}-form-field-input" placeholder="First Name" />
    <div class="${APP_ID}-form-field-error-container">
      <span name="${FORM_CONTROL.signUpForm.firstNameError.name}" id="${FORM_CONTROL.signUpForm.firstNameError.id}" class="${APP_ID}-caption-text"></span>
    </div>
  </div>
  <!-- last name -->
  <div class="${APP_ID}-form-control ${APP_ID}-form-control-last-name ${APP_ID}-width-100">
    <input name="${FORM_CONTROL.signUpForm.lastName.name}" id="${FORM_CONTROL.signUpForm.lastName.id}" type="text" class="${APP_ID}-form-field-input" placeholder="Last Name" />
    <div class="${APP_ID}-form-field-error-container">
      <span name="${FORM_CONTROL.signUpForm.lastNameError.name}" id="${FORM_CONTROL.signUpForm.lastNameError.id}" class="${APP_ID}-caption-text"></span>
    </div>
  </div>
</div>
<!-- email address -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.signUpForm.email.name}" id="${FORM_CONTROL.signUpForm.email.id}" type="text" class="${APP_ID}-form-field-input" placeholder="Email Address" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.signUpForm.emailError.name}" id="${FORM_CONTROL.signUpForm.emailError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- password -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.signUpForm.password.name}" id="${FORM_CONTROL.signUpForm.password.id}" type="password" class="${APP_ID}-form-field-input" placeholder="Password" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.signUpForm.passwordError.name}" id="${FORM_CONTROL.signUpForm.passwordError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- confirm password -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.signUpForm.confirmPassword.name}" id="${FORM_CONTROL.signUpForm.confirmPassword.id}" type="password" class="${APP_ID}-form-field-input" placeholder="Confirm Password" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.signUpForm.confirmPasswordError.name}" id="${FORM_CONTROL.signUpForm.confirmPasswordError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- form submit message -->
<div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
  <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[SIGN_UP_FORM]}" class="${APP_ID}-caption-text"></span>
</div>
<!-- submit button -->
<button id="${FORM_SUBMIT_BUTTON_ID.signUpForm.submitButton}" class="${APP_ID}-button ${APP_ID}-button-primary">
  <span class="${APP_ID}-button-text">Submit</span>
</button>
`;
};

const signUpOtpFormHtml = () => {
  return `<div class="${APP_ID}-form-helper-message-container">
  <p class="${APP_ID}-body1">We've sent an OTP to your email - ${appData.email}, enter the same below and click on submit button.</p>
</div>
<!-- otp -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.signUpOtpForm.emailOtp.name}" id="${FORM_CONTROL.signUpOtpForm.emailOtp.id}" type="password" class="${APP_ID}-form-field-input" placeholder="OTP" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.signUpOtpForm.emailOtpError.name}" id="${FORM_CONTROL.signUpOtpForm.emailOtpError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- form submit message -->
<div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
  <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[SIGN_UP_OTP_FORM]}" class="${APP_ID}-caption-text"></span>
</div>
<div class="${APP_ID}-sm-block-md-flex">
  <!-- resend otp button -->
  <button id="${FORM_SUBMIT_BUTTON_ID.signUpOtpForm.resendEmailOtp}" class="${APP_ID}-button ${APP_ID}-button-primary ${APP_ID}-form-control-btn-1">
    <span id="${APP_ID}-sign-up-otp-form-resend-email-otp-text" class="${APP_ID}-button-text">Resend OTP</span>
  </button>
  <!-- submit button -->
  <button id="${FORM_SUBMIT_BUTTON_ID.signUpOtpForm.submitButton}" class="${APP_ID}-button ${APP_ID}-button-primary ${APP_ID}-form-control-btn-2">
    <span class="${APP_ID}-button-text">Submit</span>
  </button>
</div>
`;
};

const forgotPasswordFormHtml = () => {
  return `<div class="${APP_ID}-app-header">
  <h2 id="${APP_ID}-app-header-text" class="${APP_ID}-h2">Forgot Password${stLoginHandlerOpenedAs === MODAL ? modalCloseButtonHtml() : ""}</h2>
</div>
<div id="${APP_ID}-app-body" class="${APP_ID}-app-body">
  <div ${stLoginHandlerOpenedAs === MODAL ? `class="${APP_ID}-max-width-480px"` : ""}>
    <p class="${APP_ID}-body1 ${APP_ID}-mt-14 ${APP_ID}-mb-14">Please enter your email address. You will receive an OTP that you have to enter in the next screen to create a new password.</p>
  </div>
  <!-- email address -->
  <div class="${APP_ID}-form-control">
    <input name="${FORM_CONTROL.forgotPasswordForm.email.name}" id="${FORM_CONTROL.forgotPasswordForm.email.id}" type="text" class="${APP_ID}-form-field-input" placeholder="Email Address" />
    <div class="${APP_ID}-form-field-error-container">
      <span name="${FORM_CONTROL.forgotPasswordForm.emailError.name}" id="${FORM_CONTROL.forgotPasswordForm.emailError.id}" class="${APP_ID}-caption-text"></span>
    </div>
  </div>
  <!-- form submit message -->
  <div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
    <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[FORGOT_PASSWORD_FORM]}" class="${APP_ID}-caption-text"></span>
  </div>
  <!-- submit button -->
  <button id="${FORM_SUBMIT_BUTTON_ID.forgotPasswordForm.submitButton}" class="${APP_ID}-button ${APP_ID}-button-primary">
    <span class="${APP_ID}-button-text">Submit</span>
  </button>
  ${linkToReturnToLoginHtml()}
</div>
`;
};

const resetPasswordFormHtml = () => {
  return `<div class="${APP_ID}-app-header">
  <h2 id="${APP_ID}-app-header-text" class="${APP_ID}-h2">Reset Password${stLoginHandlerOpenedAs === MODAL ? modalCloseButtonHtml() : ""}</h2>
</div>
<div id="${APP_ID}-app-body" class="${APP_ID}-app-body">
  <div ${stLoginHandlerOpenedAs === MODAL ? `class="${APP_ID}-max-width-480px"` : ""}>
  <p class="${APP_ID}-body1 ${APP_ID}-mt-14 ${APP_ID}-mb-14">
    Please type a new password for your account below and enter the OTP sent to your email address${appData.forgotPasswordEmail ? `&nbsp;<span class="${APP_ID}-ft-wt-500">${appData.forgotPasswordEmail}</span>.` : "."}
  </p>
</div>
<!-- password -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.resetPasswordForm.password.name}" id="${FORM_CONTROL.resetPasswordForm.password.id}" type="password" class="${APP_ID}-form-field-input" placeholder="Password" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.resetPasswordForm.passwordError.name}" id="${FORM_CONTROL.resetPasswordForm.passwordError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- confirm password -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.resetPasswordForm.confirmPassword.name}" id="${FORM_CONTROL.resetPasswordForm.confirmPassword.id}" type="password" class="${APP_ID}-form-field-input" placeholder="Confirm Password" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.resetPasswordForm.confirmPasswordError.name}" id="${FORM_CONTROL.resetPasswordForm.confirmPasswordError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- otp -->
<div class="${APP_ID}-form-control">
  <input name="${FORM_CONTROL.resetPasswordForm.emailOtp.name}" id="${FORM_CONTROL.resetPasswordForm.emailOtp.id}" type="password" class="${APP_ID}-form-field-input" placeholder="OTP" />
  <div class="${APP_ID}-form-field-error-container">
    <span name="${FORM_CONTROL.resetPasswordForm.emailOtpError.name}" id="${FORM_CONTROL.resetPasswordForm.emailOtpError.id}" class="${APP_ID}-caption-text"></span>
  </div>
</div>
<!-- form submit message -->
<div class="${FORM_SUBMIT_MESSAGE_CONTAINER_ID}">
  <span id="${FORM_SUBMIT_MESSAGE_TEXT_ID[RESET_PASSWORD_FORM]}" class="${APP_ID}-caption-text"></span>
</div>
<!-- submit button -->
<button id="${FORM_SUBMIT_BUTTON_ID.resetPasswordForm.submitButton}" class="${APP_ID}-button ${APP_ID}-button-primary">
  <span class="${APP_ID}-button-text">Submit</span>
</button>
<div id="${APP_ID}-form-switch-link-container">
  ${linkToGoBackToForgotPasswordHtml()}
</div>
`;
};

const linkToForgotPasswordHtml = () => {
  return `<div class="${APP_ID}-mt-4 ${APP_ID}-mb-4 ${APP_ID}-text-right">
  <button id="${FORGOT_PASSWORD_LINK_ID}" class="${APP_ID}-link-button ${APP_ID}-caption-text ${APP_ID}-link-text ${APP_ID}-ml-auto">Forgot Password?</button>
</div>`;
};

const linkToGoBackToForgotPasswordHtml = () => {
  return `<div class="${APP_ID}-mt-4 ${APP_ID}-mb-4 ${APP_ID}-text-center">
  <button id="${FORGOT_PASSWORD_LINK_ID}" class="${APP_ID}-link-button ${APP_ID}-caption-text ${APP_ID}-link-text ${APP_ID}-ml-auto ${APP_ID}-mr-auto">Go Back</button>
</div>
`;
};

const linkToReturnToLoginHtml = () => {
  return `<div class="${APP_ID}-mt-4 ${APP_ID}-mb-4 ${APP_ID}-text-center">
  <button id="${RETURN_TO_LOGIN_LINK_ID}" class="${APP_ID}-link-button ${APP_ID}-caption-text ${APP_ID}-link-text ${APP_ID}-ml-auto ${APP_ID}-mr-auto">Return to Login</button>
</div>
`;
};

const linkToLoginHtml = () => {
  return `<span class="${APP_ID}-caption-text">Already have an account? Click&nbsp;<button id="${LOGIN_LINK_ID}" class="${APP_ID}-link-button ${APP_ID}-link-text">here</button>&nbsp;to Log in.</span>
  `;
};

const linkToSignUpHtml = () => {
  return `<span class="${APP_ID}-caption-text">Don't have an account? Click&nbsp;<button id="${SIGN_UP_LINK_ID}" class="${APP_ID}-link-button ${APP_ID}-link-text">here</button>&nbsp;to Sign up.</span>
  `;
};

const showCosellPublishForm = (cb, cbArgs) => {
  try {
    let appContent = document.querySelector(`#${APP_ID}-app-content`);
    appContent.innerHTML = cosellPublishFormHtml(stLoginHandlerOpenedAs);

    if (cb) {
      cb(...cbArgs);
    }
  } catch (err) {
    console.error(err);
  }
};

const showMainLoginForm = () => {
  try {
    let appContent = document.querySelector(`#${APP_ID}-app-content`);
    appContent.innerHTML = mainLoginFormHtml(stLoginHandlerOpenedAs);

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }

    initGoogle();  // initiating google login
    initFacebook(); // initiating facebook login
  } catch (err) {
    console.error(err);
  }
};

const showLoginForm = () => {
  try {
    showSocialLoginForm();
    appData.activeForm = LOGIN_FORM;
    let modalHeader = document.querySelector(`#${APP_ID}-app-header-text`);
    let formContainer = document.querySelector(`#${APP_ID}-login-sign-up-form-container`);
    let linkToForm = document.querySelector(`#${APP_ID}-link-to-login-sign-up-container`);
    let googleButton = document.querySelector(`#${APP_ID}-social-button-text-google`);
    let facebookButton = document.querySelector(`#${APP_ID}-social-button-text-facebook`);

    modalHeader.innerHTML = `Login${stLoginHandlerOpenedAs === MODAL ? modalCloseButtonHtml() : ""}`;
    formContainer.innerHTML = loginFormHtml();
    linkToForm.innerHTML = linkToSignUpHtml();
    googleButton.innerText = "Log in with Google";
    facebookButton.innerText = "Log in with Facebook";

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }
  } catch (err) {
    console.error(err);
  }
};

const showSignUpForm = () => {
  try {
    showSocialLoginForm();
    appData.activeForm = SIGN_UP_FORM;
    let modalHeader = document.querySelector(`#${APP_ID}-app-header-text`);
    let formContainer = document.querySelector(`#${APP_ID}-login-sign-up-form-container`);
    let linkToForm = document.querySelector(`#${APP_ID}-link-to-login-sign-up-container`);
    let googleButton = document.querySelector(`#${APP_ID}-social-button-text-google`);
    let facebookButton = document.querySelector(`#${APP_ID}-social-button-text-facebook`);

    modalHeader.innerHTML = `Sign-up${stLoginHandlerOpenedAs === MODAL ? modalCloseButtonHtml() : ""}`;
    formContainer.innerHTML = signUpFormHtml();
    linkToForm.innerHTML = linkToLoginHtml();
    googleButton.innerText = "Sign up with google";
    facebookButton.innerText = "Sign up with Facebook";

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }
  } catch (err) {
    console.error(err);
  }
};

const showSignUpOtpForm = () => {
  try {
    hideSocialLoginForm();
    let formContainer = document.querySelector(`#${APP_ID}-login-sign-up-form-container`);

    formContainer.innerHTML = signUpOtpFormHtml();

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
      setFormHelperMessageContainerMaxWidth();
    }

    setResetOtpTimer();
  } catch (err) {
    console.error(err);
  }
};

const showForgotPasswordForm = () => {
  try {
    let appContent = document.querySelector(`#${APP_ID}-app-content`);
    appContent.innerHTML = forgotPasswordFormHtml();

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }
  } catch (err) {
    console.error(err);
  }
};

const showResetPasswordForm = () => {
  try {
    let appContent = document.querySelector(`#${APP_ID}-app-content`);
    appContent.innerHTML = resetPasswordFormHtml();

    if (stLoginHandlerOpenedAs === MODAL) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }
  } catch (err) {
    console.error(err);
  }
};

const showReturnToLoginFromResetPassword = () => {
  try {
    let elem = document.querySelector(`#${APP_ID}-form-switch-link-container`);
    elem.innerHTML = linkToReturnToLoginHtml();
  } catch (err) {
    console.error(err);
  }
};

// createForm
const createForm = (divId, client, callback) => {
  try {
    if (!(divId && typeof divId === "string")) {
      throw "renderSTLoginForm(): divId has not been provided as first argument or it is provided but is not a string";
    }

    if (!(document.getElementById(divId) && document.getElementById(divId).nodeName === "DIV")) {
      throw `renderSTLoginForm(): a div with the id attribute as "${divId}" could not be found in the document`;
    }

    if (client && typeof client === "object") {
      updateGlobalAppData(client);
    } else {
      throw "renderSTLoginForm(): client details object has not been provided as second argument or it is provided but is not an object";
    }

    if (client.isCosell && !(client.cosell && typeof client.cosell === "object" && client.cosell.origin && client.cosell.productId && client.cosell.productVendorId)) {
      throw `renderSTLoginForm(): ${INCORRECT_COSELL_DETAILS_MESSAGE}`;
    }

    if (callback && typeof callback === "function") {
      sendAppEvent = callback;  // assigning the reference of the callback function
    } else {
      throw "renderSTLoginForm(): a callback function as third argument has not been provided or it is provided but is not a function";
    }

    // set app instance count
    appInstanceCount = 1;

    const parentDiv = document.getElementById(divId);
    const formRootDiv = document.createElement("div");
    formRootDiv.id = `${APP_ID}-root`;
    formRootDiv.classList.add(`${APP_ID}-version-${APP_VERSION}`);

    let formHtml = "";

    if (client.isCosell) {
      if (client.cosell.token) {
        formHtml = `<div id="${APP_ID}-app-content" class="${APP_ID}-app-content">${cosellPublishFormHtml(FORM)}</div>${appFooterHtml()}`;
      } else {
        formHtml = `<div id="${APP_ID}-app-content" class="${APP_ID}-app-content">${cosellStepsFormHtml(FORM)}</div>${appFooterHtml()}`;
      }
    } else {
      formHtml = `<div id="${APP_ID}-app-content" class="${APP_ID}-app-content">${mainLoginFormHtml(FORM)}</div>${appFooterHtml()}`;
    }

    formRootDiv.innerHTML = formHtml;

    // removing form if already added to document body
    removeFormOrModal();

    attachFormOrModalEvents(formRootDiv);

    parentDiv.appendChild(formRootDiv);

    appData.activeForm = LOGIN_FORM;
    stLoginHandlerOpenedAs = FORM;

    if (!client.isCosell) {
      initGoogle();  // initiating google login
      initFacebook(); // initiating facebook login
    }

    if (client.isCosell) {
      isCosellJourney = true;

      if (client.cosell.token) {
        generatePublishLinks();
      }
    }

    // sending form rendered event
    sendAppEvent(getAppEventData(APP_EVENT_FORM_RENDERED, { token: null }));
  } catch (err) {
    console.error(err);
  }
};

// createModal
const createModal = (client, callback) => {
  try {
    if (client && typeof client === "object") {
      updateGlobalAppData(client);
    } else {
      throw "openSTLoginModal(): client details object has not been provided as first argument or it is provided but is not an object";
    }

    if (client.isCosell && !(client.cosell && typeof client.cosell === "object" && client.cosell.origin && client.cosell.productId && client.cosell.productVendorId)) {
      throw `openSTLoginModal(): ${INCORRECT_COSELL_DETAILS_MESSAGE}`;
    }

    if (callback && typeof callback === "function") {
      sendAppEvent = callback;  // assigning the reference of the callback function
    } else {
      throw "openSTLoginModal(): a callback function as second argument has not been provided or it is provided but is not a function";
    }

    // set app instance count
    appInstanceCount = 1;

    let rootDiv = document.createElement("div");
    rootDiv.id = `${APP_ID}-root`;
    rootDiv.classList.add(`${APP_ID}-version-${APP_VERSION}`);

    let modalHtml = `<div class="${APP_ID}-modal-root">
    <div class="${APP_ID}-modal-backdrop"></div>
    <div class="${APP_ID}-modal-container">
    <div class="${APP_ID}-modal">
    <div id="${APP_ID}-app-content" class="${APP_ID}-app-content">`;

    if (client.isCosell) {
      if (client.cosell.token) {
        modalHtml += cosellPublishFormHtml(MODAL);
      } else {
        modalHtml += cosellStepsFormHtml(MODAL);
      }
    } else {
      modalHtml += mainLoginFormHtml(MODAL);
    }

    modalHtml += `</div>
    ${appFooterHtml()}
    </div>
    </div>
    </div>
    </div>`;

    rootDiv.innerHTML = modalHtml;

    // removing modal if already added to document body
    removeFormOrModal();

    attachFormOrModalEvents(rootDiv);

    document.body.appendChild(rootDiv);

    if (!client.isCosell) {
      setFormFieldErrorContainerMaxWidth();
      setFormSubmitMessageContainerMaxWidth();
    }

    appData.activeForm = LOGIN_FORM;
    stLoginHandlerOpenedAs = MODAL;

    if (!client.isCosell) {
      initGoogle();  // initiating google login
      initFacebook(); // initiating facebook login
    }

    if (client.isCosell) {
      isCosellJourney = true;

      if (client.cosell.token) {
        generatePublishLinks();
      }
    }

    // sending modal open event
    sendAppEvent(getAppEventData(APP_EVENT_MODAL_OPENED, { token: null }));
  } catch (err) {
    console.error(err);
  }
};

const attachFormOrModalEvents = (elem) => {
  // attaching click event listener to the root div
  elem.addEventListener("click", (e) => {
    try {
      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.cosellStepsForm.proceedToRegister) {
        showMainLoginForm();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyShareLink) {
        copyShareLink();
        publishProduct(getProductPublishRequestBody(MEDIUM_COPY));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.cosellPublishForm.copyEmbedCode) {
        copyEmbedCode();
        publishProduct(getProductPublishRequestBody(MEDIUM_EMBED));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === SOCIAL_MEDIA_SHARE_BUTTON_ID.facebook) {
        handleSocialMediaShare(SOCIAL_MEDIA_PLATFORMS.facebook);
        publishProduct(getProductPublishRequestBody(SOCIAL_MEDIA_PLATFORMS.facebook));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === SOCIAL_MEDIA_SHARE_BUTTON_ID.twitter) {
        handleSocialMediaShare(SOCIAL_MEDIA_PLATFORMS.twitter);
        publishProduct(getProductPublishRequestBody(SOCIAL_MEDIA_PLATFORMS.twitter));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === SOCIAL_MEDIA_SHARE_BUTTON_ID.pinterest) {
        handleSocialMediaShare(SOCIAL_MEDIA_PLATFORMS.pinterest);
        publishProduct(getProductPublishRequestBody(SOCIAL_MEDIA_PLATFORMS.pinterest));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === SOCIAL_MEDIA_SHARE_BUTTON_ID.whatsapp) {
        handleSocialMediaShare(SOCIAL_MEDIA_PLATFORMS.whatsapp);
        publishProduct(getProductPublishRequestBody(SOCIAL_MEDIA_PLATFORMS.whatsapp));
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORGOT_PASSWORD_LINK_ID) {
        showForgotPasswordForm();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === RETURN_TO_LOGIN_LINK_ID) {
        showMainLoginForm();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === `${APP_ID}-modal-close-button`) {
        closeSTLoginModal(APP_EVENT_MODAL_CLOSED_BY_USER);
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === SIGN_UP_LINK_ID) {
        showSignUpForm();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === LOGIN_LINK_ID) {
        showLoginForm();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === LOG_IN_WITH_FACEBOOK_BUTTON_ID) {
        handleLogInToFacebook();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.loginForm.submitButton) {
        const valid = validateForm(LOGIN_FORM, FORM_CONTROL_FIELD.all);

        if (valid) {
          handleLoginFormSubmit();
        }
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.signUpForm.submitButton) {
        const valid = validateForm(SIGN_UP_FORM, FORM_CONTROL_FIELD.all);

        if (valid) {
          handleSignUpFormSubmit();
        }
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.signUpOtpForm.resendEmailOtp) {
        setResetOtpTimer();
        resendVerificationOtp();
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.signUpOtpForm.submitButton) {
        const valid = validateForm(SIGN_UP_OTP_FORM, FORM_CONTROL_FIELD.all);

        if (valid) {
          handleSignUpOtpSubmit();
        }
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.forgotPasswordForm.submitButton) {
        const valid = validateForm(FORGOT_PASSWORD_FORM, FORM_CONTROL_FIELD.all);

        if (valid) {
          handleForgotPasswordFormSubmit();
        }
      }

      if (getPropIfNotNull(e.target.closest("button"), "id") === FORM_SUBMIT_BUTTON_ID.resetPasswordForm.submitButton) {
        const valid = validateForm(RESET_PASSWORD_FORM, FORM_CONTROL_FIELD.all);

        if (valid) {
          handleResetPasswordFormSubmit();
        }
      }
    } catch (err) {
      console.error(err);
    }
  });

  // attaching input event listener to the root div
  elem.addEventListener("input", (e) => {
    handleFormInputFieldValidations(e);
  });

  // attaching focusout event listener to the root div
  elem.addEventListener("focusout", (e) => {
    handleFormInputFieldValidations(e);
  });

  // attaching change event listener to the root div
  elem.addEventListener("change", (e) => {
    if (getPropIfNotNull(e.target.closest("select"), "id") === `${APP_ID}-form-control-dial-code-dropdown`) {
      // selectCountry(e.target);
    }
  });

  // attaching change event listener to the root div
  elem.addEventListener("keyup", (e) => {
    if (e.key === 'Enter' || e.keyCode === 13) {
      const inputId = getPropIfNotNull(e.target.closest("input"), "id");
      if (inputId) {
        if (LOGIN_FORM_CONTROL_ID_LIST.includes(inputId)) {
          const valid = validateForm(LOGIN_FORM, FORM_CONTROL_FIELD.all);

          if (valid) {
            handleLoginFormSubmit();
          }
        } else if (SIGN_UP_FORM_CONTROL_ID_LIST.includes(inputId)) {
          const valid = validateForm(SIGN_UP_FORM, FORM_CONTROL_FIELD.all);

          if (valid) {
            handleSignUpFormSubmit();
          }
        } else if (SIGN_UP_OTP_FORM_CONTROL_ID_LIST.includes(inputId)) {
          const valid = validateForm(SIGN_UP_OTP_FORM, FORM_CONTROL_FIELD.all);

          if (valid) {
            handleSignUpOtpSubmit();
          }
        } else if (FORGOT_PASSWORD_FORM_CONTROL_ID_LIST.includes(inputId)) {
          const valid = validateForm(FORGOT_PASSWORD_FORM, FORM_CONTROL_FIELD.all);

          if (valid) {
            handleForgotPasswordFormSubmit();
          }
        } else if (RESET_PASSWORD_FORM_CONTROL_ID_LIST.includes(inputId)) {
          const valid = validateForm(RESET_PASSWORD_FORM, FORM_CONTROL_FIELD.all);

          if (valid) {
            handleResetPasswordFormSubmit();
          }
        }
      }
    }
  });

  const handleFormInputFieldValidations = (e) => {
    try {
      if (LOGIN_FORM_CONTROL_ID_LIST.includes(getPropIfNotNull(e.target.closest("input"), "id"))) {
        validateForm(LOGIN_FORM, e.target.closest("input").name);
      } else if (SIGN_UP_FORM_CONTROL_ID_LIST.includes(getPropIfNotNull(e.target.closest("input"), "id"))) {
        validateForm(SIGN_UP_FORM, e.target.closest("input").name);
      } else if (SIGN_UP_OTP_FORM_CONTROL_ID_LIST.includes(getPropIfNotNull(e.target.closest("input"), "id"))) {
        validateForm(SIGN_UP_OTP_FORM, e.target.closest("input").name);
      } else if (FORGOT_PASSWORD_FORM_CONTROL_ID_LIST.includes(getPropIfNotNull(e.target.closest("input"), "id"))) {
        validateForm(FORGOT_PASSWORD_FORM, e.target.closest("input").name);
      } else if (RESET_PASSWORD_FORM_CONTROL_ID_LIST.includes(getPropIfNotNull(e.target.closest("input"), "id")) && !formSubmitStatus.resetPasswordForm) {
        validateForm(RESET_PASSWORD_FORM, e.target.closest("input").name);
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleLoginFormSubmit = async () => {
    const token = await loginAndGetToken();

    if (token) {
      sendAppEvent(getAppEventData(APP_EVENT_LOGIN_SUCCESS, { token: token }));

      if (isCosellJourney) {
        showCosellPublishForm(generatePublishLinks, [token]);
      }
    } else {
      sendAppEvent(getAppEventData(APP_EVENT_LOGIN_FAILED, { token: null }));
    }
  };

  const handleSignUpFormSubmit = async () => {
    const status = await signUpAndGetStatus();
    if (status === FORM_SUBMIT_STATUS.success) {
      showSignUpOtpForm();
    }
  };

  const handleSignUpOtpSubmit = async () => {
    const token = await submitOtpAndGetToken();

    if (token) {
      clearResendOtpTimer();
      sendAppEvent(getAppEventData(APP_EVENT_SIGN_UP_SUCCESS, { token: token }));

      if (isCosellJourney) {
        showCosellPublishForm(generatePublishLinks, [token]);
      } else {
        showSignUpForm();
      }
    } else {
      sendAppEvent(getAppEventData(APP_EVENT_SIGN_UP_FAILED, { token: null }));
    }
  };

  const handleForgotPasswordFormSubmit = async () => {
    const status = await forgotPasswordFormSubmitAndGetStatus();
    if (status === FORM_SUBMIT_STATUS.success) {
      showResetPasswordForm();
    }
  };

  const handleResetPasswordFormSubmit = async () => {
    const status = await resetPasswordFormSubmitAndGetStatus();
    if (status === FORM_SUBMIT_STATUS.success) {
      formSubmitStatus.resetPasswordForm = true;
      disableButtonById(FORM_SUBMIT_BUTTON_ID[RESET_PASSWORD_FORM].submitButton);
      resetForm(RESET_PASSWORD_FORM);
      disableFormInputFields(RESET_PASSWORD_FORM);
      showReturnToLoginFromResetPassword();
      formSubmitStatus.resetPasswordForm = false;
    }
  };
}

const removeFormOrModal = () => {
  const elem = document.getElementById(`${APP_ID}-root`);
  if (elem) {
    elem.parentNode.removeChild(elem);
  }
};
